export default __webpack_public_path__ + "static/media/WM0490.34I-43517_-26037_0.058dd3a1.jpg";